import { BusinessProfileUpdateStrategy } from '../../../../providers/BusinessProfileProvider';

export default {
  modals: {
    update_strategy: {
      title: 'Mitä toimipaikkoja tulisi päivittää?',
      form: {
        update_strategy: {
          options: {
            [BusinessProfileUpdateStrategy.All]: 'Kaikki toimipaikkani',
            [BusinessProfileUpdateStrategy.Current]: 'Vain nykyinen valittu toimipaikka',
          },
        },
      },
      buttons: {
        confirm: 'Vahvista',
      },
    },
  },
  toasts: {
    error: 'Jokin meni pieleen, yritä uudelleen tai ota yhteyttä tekniseen tukeen',
    success: 'Muutokset on tallennettu onnistuneesti!',
  },
};
